
exports.pbkdf2 = require('./lib/async')

exports.pbkdf2Sync = require('./lib/sync')



//////////////////
// WEBPACK FOOTER
// ./node_modules/pbkdf2/browser.js
// module id = 47
// module chunks = 0